import useBankAccounts, { useCreateBankAccount, useRemoveBankAccount, useUpdateBankAccount } from 'hooks/v1/pages/bank-accounts/useBankAccounts';
import React, { createContext, useContext } from 'react';

// Membuat context untuk loading
const BankAccountContext = createContext();

// Provider untuk context loading
export const BankAccountProvider = ({ children }) => {
    const bankAccountsHook = useBankAccounts();
    const createBankAccountHook = useCreateBankAccount({ bankAccounts: bankAccountsHook.bankAccounts, setBankAccounts: bankAccountsHook.setBankAccounts });
    const updateBankAccountHook = useUpdateBankAccount({ bankAccounts: bankAccountsHook.bankAccounts, setBankAccounts: bankAccountsHook.setBankAccounts });
    const removeBankAccountHook = useRemoveBankAccount({ bankAccounts: bankAccountsHook.bankAccounts, setBankAccounts: bankAccountsHook.setBankAccounts });

    const contextValue = {
        ...bankAccountsHook,
        ...createBankAccountHook,
        ...updateBankAccountHook,
        ...removeBankAccountHook,
    };

    return (
        <BankAccountContext.Provider value={contextValue}>
            {children}
        </BankAccountContext.Provider>
    );
};

// Hook untuk mengakses context loading
export const useBankAccount = () => {
    const context = useContext(BankAccountContext);
    if (!context) {
        throw new Error('useBankAccount must be used within a BankAccountProvider');
    }
    return context;
};